import React, { Fragment, useMemo } from 'react';
import { Chip, Dialog, DialogContent, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Icon from '@mdi/react';
import pluralize from 'pluralize';
import styled from 'styled-components';
import { IconSize } from '../../../lib';
import { CourseIconPath } from '../../Icons/CourseIcon';
import { UserListItem } from '../../ListItems';
import { buildDisplayName } from './shared';
const CollaboratorTypeText = styled.div `
    margin-top: 1rem;
    text-transform: uppercase;
    color: ${(props) => props.theme.colors.textSecondary};
    font-size: ${(props) => props.theme.fonts.textSizeSmall};
`;
const StyledDialogContent = styled(DialogContent) `
    padding: 1.5rem !important;
`;
const FlexContainer = styled.div `
    display: flex;
    width: 100%;
    justify-content: space-between;
`;
const IconCloseButton = styled(IconButton) `
    float: right;

    & svg {
        width: ${IconSize.Medium};
        color: ${(props) => props.theme.colors.textSecondary};
    }
`;
const authorTypeToString = (authorType) => {
    switch (authorType) {
        case 'peerReviewer':
            return 'Peer reviewer';
        case 'author':
            return 'Author';
        default:
            return authorType;
    }
};
export const CollaboratorsModal = ({ open, onClose, collaborators, onClick, parentTitle }) => {
    const groupedCollaborators = useMemo(() => {
        return collaborators.reduce((memo, profile) => {
            var _a;
            for (const authorType of (_a = profile.authorTypes) !== null && _a !== void 0 ? _a : []) {
                const authorTypeString = authorTypeToString(authorType);
                if (memo[authorTypeString]) {
                    memo[authorTypeString].push(profile);
                }
                else {
                    memo[authorTypeString] = [profile];
                }
            }
            return memo;
        }, {});
    }, [collaborators]);
    return (React.createElement(Dialog, { open: open, onClose: onClose, onClick: (e) => e.stopPropagation(), fullWidth: true, maxWidth: "sm" },
        React.createElement(StyledDialogContent, null,
            React.createElement(FlexContainer, null,
                React.createElement("h3", null, "Collaborators"),
                React.createElement(IconCloseButton, { "aria-label": "close modal", onClick: onClose },
                    React.createElement(CloseIcon, null))),
            parentTitle ? (React.createElement(Chip, { size: "small", icon: React.createElement(Icon, { path: CourseIconPath, size: IconSize.Small }), label: parentTitle, variant: "outlined" })) : null,
            Object.entries(groupedCollaborators).map(([authorType, userInfo]) => (React.createElement(Fragment, { key: authorType },
                React.createElement(CollaboratorTypeText, null, pluralize(authorType)),
                userInfo.map((info, index) => {
                    var _a;
                    const displayName = buildDisplayName(info);
                    return displayName ? (React.createElement(UserListItem, { onClick: () => {
                            if (onClick) {
                                onClick(info);
                            }
                        }, key: index, title: displayName, avatarSrc: (_a = info.imageUrl) !== null && _a !== void 0 ? _a : undefined })) : null;
                })))))));
};
//# sourceMappingURL=CollaboratorsModal.js.map